import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthenticationStore } from '@pflegix/authentication';

// eslint-disable-next-line sonarjs/function-return-type
export const loginGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);

  const store = inject(AuthenticationStore);

  if (store.currentUser()) {
    return router.createUrlTree(['/']);
  }

  return true;
};
